import React, { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Entity } from '@debbie/common/dist';
import { getContactPerson } from '@debbie/common/dist/customers';
import { TemplateType, SMSTemplateMentionSuggestions, } from '@debbie/common/dist/templates';
import { cancelDebounce, debounce } from '@debbie/common/dist/util';
import { c } from '@debbie/cortex/dist';
import { selectAutoCall } from '@debbie/cortex/dist/newInteractions/selectors';
import { Button, Badge, Modal } from '../';
import THEME from '../../theme';
import { parseText, PARSE_RESULT_TYPE } from '../../utils/templates';
import AutoCallActions from '../AutoCallActions';
import Info from '../Icons/Info';
import MentionExplanation from './MentionExplanation';
import TemplateSearch from './TemplateSearch';
import { toHtml } from './utils';
const AutoCallInteraction = (props) => {
    const { caseId } = props.case;
    const autocall = useSelector((s) => selectAutoCall(s, caseId));
    const lang = useSelector((s) => s.lang);
    const [mentionExplanationModalOpen, setMentionExplanationModalOpen] = useState(false);
    const [reset, setReset] = useState(false);
    const [content, setContent] = useState(autocall.editorState);
    useEffect(() => {
        if (reset) {
            setContent(autocall.editorState);
            setReset(false);
        }
    }, [autocall.editorState]);
    const toggleMentionExplanation = () => {
        setMentionExplanationModalOpen(!mentionExplanationModalOpen);
    };
    const contactPerson = getContactPerson(props.customer);
    const toPhone = contactPerson === null || contactPerson === void 0 ? void 0 : contactPerson.details.phone;
    const registerAutoCall = () => {
        cancelDebounce('autocall-content');
        setReset(true);
        c.newInteractions.registerAutoCall(caseId, Entity.Case, autocall, {
            voiceName: 'Mads',
            transcript: parseText(toHtml(content), lang.mentions, PARSE_RESULT_TYPE.TEXT),
            fromCountryCode: '45',
            fromPhoneNumber: '54543899',
            toCountryCode: toPhone === null || toPhone === void 0 ? void 0 : toPhone.locale,
            toPhoneNumber: toPhone === null || toPhone === void 0 ? void 0 : toPhone.number,
            actions: autocall.actions,
        }, 'caseworker');
    };
    const phoneValidation = contactPerson &&
        contactPerson.details.phoneValidations &&
        contactPerson.details.phoneValidations.find((pV) => (pV.phone && pV.phone.number) ==
            (contactPerson.details.phone && contactPerson.details.phone.number) &&
            (pV.phone && pV.phone.locale) ==
                (contactPerson.details.phone && contactPerson.details.phone.locale));
    return (React.createElement(React.Fragment, null,
        React.createElement(TemplateSearch, { interaction: autocall, templateType: TemplateType.AUTOCALL, case: props.case, customer: props.customer, onChange: (state) => {
                setContent(state);
            } }),
        React.createElement("div", null,
            []
                .concat(phoneValidation &&
                phoneValidation.originalCarrier &&
                phoneValidation.originalCarrier.name
                ? {
                    content: phoneValidation.originalCarrier.name,
                }
                : [])
                .concat(phoneValidation &&
                phoneValidation.originalCarrier &&
                phoneValidation.originalCarrier.networkType
                ? {
                    content: lang.phoneValidation[phoneValidation.originalCarrier.networkType] || phoneValidation.originalCarrier.networkType,
                }
                : [])
                .concat(phoneValidation &&
                phoneValidation.roaming &&
                phoneValidation.roaming.status &&
                phoneValidation.roaming.status != 'not_roaming'
                ? {
                    content: lang.phoneValidation[phoneValidation.roaming.status] || phoneValidation.roaming.status,
                }
                : [])
                .concat(phoneValidation &&
                phoneValidation.reachable &&
                !['reachable', 'unknown'].includes(phoneValidation.reachable)
                ? {
                    content: phoneValidation.reachable,
                }
                : [])
                .map((tag) => (React.createElement(Badge, { theme: THEME.COLOR_ACCENT, style: { marginRight: '5px' } }, tag.content))),
            React.createElement("p", null,
                toPhone && toPhone.locale && `+${toPhone.locale} `,
                contactPerson && toPhone && toPhone.number)),
        React.createElement(StyledEditor, null,
            React.createElement(Editor, { toolbarClassName: "hide-toolbar", editorState: content, onEditorStateChange: (newEditorState) => {
                    setContent(newEditorState);
                    debounce('autocall-content', () => {
                        c.newInteractions.changeEditorState(caseId, 'autocall', newEditorState);
                    }, 1000);
                }, stripPastedStyles: true, mention: {
                    separator: ' ',
                    trigger: '@',
                    suggestions: SMSTemplateMentionSuggestions.map((tag) => ({
                        value: lang.mentions[tag],
                        text: lang.mentions[tag],
                        url: lang.mentions[tag],
                    })),
                } })),
        React.createElement("div", null,
            React.createElement(AutoCallActions, { actions: autocall.actions || [], onChange: (actions) => {
                    c.newInteractions.changeField(caseId, 'autocall', 'actions', actions);
                } }),
            React.createElement("p", { onClick: () => {
                    c.newInteractions.changeField(caseId, 'autocall', 'actions', (autocall.actions || []).concat({
                        procedureId: 'f892b601-2d51-46e6-901c-1b90556dcdf3', //empty procedure
                        id: Math.random().toLocaleString(),
                    }));
                }, style: {
                    cursor: 'pointer',
                    textTransform: 'uppercase',
                    fontWeight: 900,
                    color: THEME.COLOR_ACCENT,
                    marginTop: '0px',
                } }, lang.autoCall.addAction)),
        React.createElement("br", null),
        React.createElement(Button, { size: "small", loading: autocall.loading, disabled: !content, onClick: registerAutoCall }, lang.autoCall.call),
        React.createElement(Button, { size: "small", theme: "secondary", style: { float: 'right', marginRight: '5px' }, onClick: toggleMentionExplanation },
            React.createElement(Info, null)),
        mentionExplanationModalOpen && (React.createElement(Modal, { onToggle: toggleMentionExplanation, header: lang.interactions.explanation },
            React.createElement(MentionExplanation, { type: TemplateType.AUTOCALL })))));
};
export default AutoCallInteraction;
const StyledEditor = styled.div `
  .rdw-editor-wrapper .rdw-editor-main {
    border-top: 1px solid #ccc !important;
    border-top-left-radius: 3px !important;
    border-top-right-radius: 3px !important;
  }
`;
//# sourceMappingURL=AutoCallInteraction.js.map